import { BrowserAuthError, BrowserAuthErrorCodes } from "@azure/msal-browser";

// Silent token acquisition can fail transiently on slow or dropped mobile
// connections: the POST to the token endpoint fails, the device is offline, or
// the silent-renewal iframe times out. Callers retry these, with one exception:
// fetchToken treats timed_out while online as permanent and redirects.
export function isTransientTokenError(error: unknown): boolean {
  return (
    error instanceof BrowserAuthError &&
    (error.errorCode === BrowserAuthErrorCodes.postRequestFailed ||
      error.errorCode === BrowserAuthErrorCodes.noNetworkConnectivity ||
      error.errorCode === BrowserAuthErrorCodes.timedOut)
  );
}
